// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"styles_pageWrapper__tVRP8"};